import axios from "axios";
require("dotenv").config();

const API = process.env.REACT_APP_API;
const GROUP_GUID = process.env.REACT_APP_GROUP_GUID;
const ACCESS_TOKEN = process.env.REACT_APP_ACCESS_TOKEN;

export function create(longUrl) {
  let body = {
    long_url: longUrl.replace(/\s/g, ""),
  };
  return axios.post(`${API}/v4/bitlinks`, body, {
    headers: {
      Authorization: `Bearer ${ACCESS_TOKEN}`,
      "Content-Type": "application/json",
    },
  });
}

export function loadBitlinksByGroup(state) {
  return axios.get(`${API}/v4/groups/${GROUP_GUID}/bitlinks`, {
    data: {},
    query: { size: 9999 },
    headers: {
      Authorization: `Bearer ${ACCESS_TOKEN}`,
      "Content-Type": "application/json",
    },
  });
}

export async function getClicks(state, bitlink) {
  return await axios.get(`${API}/v4/bitlinks/${bitlink}/clicks`, {
    headers: { Authorization: `Bearer ${ACCESS_TOKEN}` },
  });
}
